
import { Component, Mixins, Watch } from 'vue-property-decorator';
import BScroll from 'better-scroll';
import JsZip, { JSZipObject } from 'jszip';
import { Mutation, State } from 'vuex-class';
import { Popover } from 'element-ui';
import { ITButton } from '@/components/Button/index.d';
import Button from '@/components/Button/tButton.vue';
import tModal from '@/components/Modal/index.vue';
import noData from '@/components/noData/index.vue';
import { IModalConf } from '@/components/Modal/index.d';
import BSMinix from '@/views/Home/mixins/bsMixin';
import PageMinix from '@/views/Home/mixins/pageMixin';
import api from '@/api/asset';
import { IAssetSearchForm } from '@/types/asset.d';
import { tSearch } from '@/components/Search/index';
import tTag from './components/tag.vue';
import tBox from './components/box.vue';
import Category from './components/category.vue';
import Allot from './components/allot.vue';
import SearchForm from './components/searchForm.vue';
import RemoveModal from './components/remove.vue';
import EditModal from './components/edit.vue';
import AllotMixin from './allotMixin';

enum AssetType {
  Sound = 'sounds',
  Sprite = 'sprites',
  Stage = 'stages',
}

@Component({
  name: 'asset',
  components: {
    tTag,
    tModal,
    tBox,
    tSearch,
    Button,
    Category,
    Popover,
    Allot,
    SearchForm,
    noData,
    RemoveModal,
    EditModal,
  },
})
export default class AssetView extends Mixins(BSMinix, PageMinix, AllotMixin) {
  @Mutation('asset/SET_ASSET_MANAGE_REMOVE_DATA') setRemoveDatas!: Function;

  @Mutation('asset/SET_ASSET_MANAGE_REMOVE_FLAG') setRemoveFlag!: Function;

  @State((state => state.asset.manage.removeData)) removeDatas!: any;

  @State((state => state.asset.manage.removeFlag)) removeFlag!: boolean;

  /* eslint-disable global-require */
  private tagConf: Array<{ name: string, imgUrl: any, value: AssetType }> = [
    {
      name: '角色',
      value: AssetType.Sprite,
      imgUrl: require('./icons/sprite.svg'),
    },
    {
      name: '声音',
      value: AssetType.Sound,
      imgUrl: require('./icons/sound.svg'),
    },
    {
      name: '背景',
      value: AssetType.Stage,
      imgUrl: require('./icons/background.svg'),
    },
  ];

  private checkModalData: {[key: string]: Array<string>} = {
    sprites: [],
    sounds: [],
    stages: [],
  };

  private uploadBtn: ITButton = {
    title: '上 传',
    type: 'primary',
    icon: 'cloud-upload',
    callback: () => this.$refs.upload.click(),
  };

  private nextBtn: ITButton = {
    title: '下一步',
    type: 'primary',
    disabled: true,
    callback: () => this.handleFirstStepSubmit(),
  };

  private submitBtn: ITButton = {
    title: '提 交',
    type: 'primary',
    callback: () => this.handleModalSubmit(),
  };

  private zipObjects: Array<JSZipObject> = [];

  public $refs!: {
    upload: HTMLInputElement,
    modal: HTMLElement,
    page: HTMLElement,
    category: Category,
    searchForm: SearchForm;
    content: HTMLElement,
    edit: EditModal,
  };

  private modalConf: IModalConf = {
    title: '请选择素材资源',
    show: false,
    close: () => this.close(),
  };

  private editModalConf: IModalConf = {
    title: '素材名字修改',
    show: false,
    close: (flag: boolean) => this.editModalClose(flag),
  };

  private rmModalConf: IModalConf = {
    title: '以下素材已被使用无法删除',
    show: false,
    close: () => this.handleRemoveClose(),
  };

  private searchValue: string = '';

  private inputShow: boolean = true; // 隐藏的上传input是否显示 此过程会销毁input元素

  private asset: { [key: string]: Array<any> } = {
    sprites: [],
    sounds: [],
    stages: [],
  };

  private unZipFiles: { [key: string]: JSZipObject } = {};

  private curModalTag: AssetType = AssetType.Sprite;

  private curPageTag: AssetType = AssetType.Sprite;

  private curModalStep: 'first' | 'second' = 'first';

  private loading: {[key: string]: boolean} = {
    page: false,
    modal: false,
    submit: false,
  };

  private bs?: BScroll;

  private datas: any = [];

  private flag: boolean = true;

  private searchTitle: string = '';

  private notAllowRemoveData: Array<any> = [];

  private activateFlag: boolean = false; // 默认不是高级搜索

  private notNeedScripts: Array<string> = [];

  private editData: any = {};

  get sb3Datas() {
    const array: Array<string> = [];
    /* eslint-disable array-callback-return */
    /* eslint-disable consistent-return */
    return this.asset[this.curModalTag].filter((em: any) => {
      if (em.name.indexOf(this.searchValue) >= 0 && !array.includes(em.md5)) {
        array.push(em.md5);
        return em;
      }
    });
  }

  mounted() {
    this.initRmoveModalEvent();
    this.page.pageSize = 50;
    this.getData(true);
    this.bs = this.initBS(this.$refs.page, { scrollbar: { fade: false } });
    this.bs.on('scrollEnd', (cood: any) => {
      if (cood.y === 0) return;
      const contentHeight: number = this.$refs.page.clientHeight;
      const wrapperHeight: number = Math.abs(this.$refs.content.getBoundingClientRect().height);
      if (this.datas.length === (this.page.total || 0)) return;
      if (this.flag) return;
      if (contentHeight + Math.abs(cood.y) > wrapperHeight - 180) {
        this.flag = true;
        this.page.pageNo += 1;
        this.getData(false);
      }
    });
    this.initBS(this.$refs.modal);
  }

  // 关闭编辑模态框
  editModalClose(flag: boolean = false) {
    this.editModalConf.show = false;
    this.editModalConf.title = '';
    this.$refs.edit.handleClear();
    if (flag) this.getData();
  }

  // 打开编辑模态框
  handleEdit(data: { id: string }) {
    const tempData = this.datas.filter((item: any) => item.id === data.id)[0];
    this.editModalConf.show = true;
    this.editModalConf.title = `${tempData.title} - 素材修改`;
    this.editData = tempData;
  }

  // 显示删除数据的模态框的初始化
  initRmoveModalEvent() {
    if (this.removeFlag && this.removeDatas.length > 0) {
      this.rmModalConf.show = true;
      this.notAllowRemoveData = this.removeDatas;
    }
  }

  // 处理点击脚本事件
  handleClickScript(md5: string) {
    const set: Set<string> = new Set(this.notNeedScripts);
    if (set.has(md5)) set.delete(md5);
    else set.add(md5);
    this.notNeedScripts = Array.from(set);
  }

  // 无法删除模态框的关闭事件
  handleRemoveClose() {
    this.rmModalConf.show = false;
    this.notAllowRemoveData = [];
    this.setRemoveFlag(false);
  }

  // 处理删除按钮的逻辑
  handleRemoveBtn() {
    const ids: string[] = [];
    Object.values(this.checkPageData).forEach((em: any) => ids.push(...em));
    this.confirm(`此操作将删除 ${ids.length} 个素材, 是否继续?`, {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.deleteAsset(ids.join(',')).then((res: any) => {
        this.getData();
        this.handleAllotModalClose();
        close();
        this.notAllowRemoveData = [];
        if (res && res.status && res.status === 208) {
          res.data.forEach((em: any) => {
            const data: any = {};
            data.common = em.commons;
            data.name = em.title;
            data.cover = `${process.env.VUE_APP_ASSET_HOST}/${em.thumbMd5}.${em.thumbExt}`;
            if (em.type === 'sound') data.cover = require('./icons/sound-bg.png');
            /* eslint-disable no-shadow */
            data.list = em.chapters.map((em: any) => ({
              id: em.courseId,
              cid: em.chapterId,
              title: `${em.courseName}-${em.courseVersion}- ${em.chapterName}`,
            }));
            this.notAllowRemoveData.push(data);
          });
          this.setRemoveDatas(this.notAllowRemoveData);
          this.rmModalConf.show = true;
          this.setRemoveFlag(true);
        }
        this.$log({
          title: '素材管理 - 删除 - 确定',
          component: 'asset/manage/index',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '素材管理 - 删除 - 取消',
      component: 'asset/manage/index',
    }));
  }

  /**
   * @notice 未经允许严禁修改
   * @author Terry
   * @description 处理模块提交
  */
  async handleModalSubmit() {
    this.loading.modal = true;
    this.loading.submit = true;
    const categories: string = await this.$refs.category.handleFormSubmit();
    if (categories) {
      /* eslint-disable no-throw-literal */
      try {
        if (await this.handleSubmitFile() && await this.handleSubmitJson(categories)) {
          this.loading.modal = false;
          this.close();
          this.getData();
        } else throw 'error';
      } catch (error) {
        if (error !== 'network error') this.msg('上传失败了，不要灰心再试一次 ~ ', 'warning');
        this.loading.modal = false;
        this.loading.submit = false;
      }
    } else {
      this.loading.modal = false;
      this.loading.submit = false;
    }
  }

  /**
   * @notice 未经允许严禁修改
   * @author Terry
   * @description 提交所需要的文件 此方法仅服务于 handleModalSubmit 方法
   * @returns Promise<any>
   */
  private handleSubmitFile(): Promise<any> {
    const promises: Array<Promise<any>> = [];
    const md5s: Array<string> = [];
    md5s.push(...this.checkModalData.stages, ...this.checkModalData.sounds);
    this.checkModalData.sprites.forEach(async (em: string) => {
      /* eslint-disable prefer-destructuring */
      /* eslint-disable no-shadow */
      const sprite: any = this.asset.sprites.filter((sprite: any) => sprite.md5 === em)[0];
      sprite.json.costumes.forEach((md5: any) => md5s.push(md5.baseLayerMD5));
      sprite.json.sounds.forEach((md5: any) => md5s.push(md5.md5));
    });
    md5s.forEach((md5: string) => {
      promises.push(this.unZipFiles[md5].async('blob').then((res: any) => new File([res], md5)));
    });
    // 处理从jszip解压文件 并 返回一个Promise
    return Promise.all(promises).then((res: File[]) => {
      const filePromises: Array<Promise<any>> = [];
      // 处理上传文件的Proimise
      /* eslint-disable no-restricted-syntax */
      for (const file of res) filePromises.push(api.uploadSb3Asset(file));
      return Promise.all(filePromises) as any;
    });
  }

  /**
   * @notice 未经允许严禁修改
   * @author Terry
   * @description 提交所需要的数据 此方法仅服务于 handleModalSubmit 方法
   * @param { string } 分类id
   * @returns Promise<any>
   */
  private handleSubmitJson(categories: string): Promise<any> {
    /* eslint-disabled (function-paren-newline) */
    const data: Array<any> = this.asset.sprites
      .filter((sprite: any) => this.checkModalData.sprites.includes(sprite.md5))
      .map((sprite: any) => ({
        type: 'sprite',
        title: sprite.name,
        thumb: sprite.md5.split('.')[0] || '',
        ext: sprite.md5.split('.')[1] || '',
        thumbData: JSON.stringify(sprite.json.costumes.map((costume: any) => costume.baseLayerMD5)),
        materialData: JSON.stringify(this.hadleSptiteScript(sprite)),
        categories: [categories],
      }));
    data.push(...this.asset.sounds
      .filter((sound: any) => this.checkModalData.sounds.includes(sound.md5))
      .map((sound: any) => ({
        type: 'sound',
        title: sound.name,
        thumb: sound.md5.split('.')[0] || '',
        ext: sound.md5.split('.')[1] || '',
        thumbData: '',
        materialData: JSON.stringify(sound),
        categories: [categories],
      })));
    data.push(...this.asset.stages
      .filter((stage: any) => this.checkModalData.stages.includes(stage.md5))
      .map((stage: any) => ({
        type: 'background',
        title: stage.name,
        thumb: stage.md5.split('.')[0] || '',
        ext: stage.md5.split('.')[1] || '',
        thumbData: '',
        materialData: JSON.stringify(stage),
        categories: [categories],
      })));
    return api.uploadAssetJson(data);
  }

  private hadleSptiteScript(sprite: any) {
    if (this.notNeedScripts.includes(sprite.md5)) {
      /* eslint-disable no-param-reassign */
      sprite.source.variables = {};
      sprite.source.lists = {};
      sprite.source.broadcasts = {};
      sprite.source.blocks = {};
      sprite.source.comments = {};
    }
    return sprite;
  }

  /**
   * @author Terry
   * @description 分配公共素材
   */
  handleAllotPublic() {
    const ids: string[] = [];
    Object.values(this.checkPageData).forEach((em: any) => ids.push(...em));
    this.handleColsePop();
    this.confirm(`你确定要将${ids.length}个素材分配给公共素材吗？`, {
      title: '确定分配',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.allotPulicAsset(JSON.stringify(ids)).then((res) => {
        close();
        this.handleAllotModalClose();
        this.$log({
          title: '机构管理 - 重置密码 - 确定',
          component: 'org/manage/tableMixin',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '素材管理 - 分配 - 公共',
      component: 'asset/manage/index.cue',
    }));
  }


  /**
   * @author Terry
   * @description 判断是否包含脚本
   */
  /* eslint-disable class-methods-use-this */
  handleHasScript(item: any): boolean {
    return item.source && (!!(Object.keys(item.source.blocks).length)
    || !!(Object.keys(item.source.broadcasts).length)
    || !!(Object.keys(item.source.comments).length)
    || !!(Object.keys(item.source.lists).length));
  }

  /**
   * @author Terry
   * @description 处理第一步骤的下一步按钮
  */
  handleFirstStepSubmit() {
    this.modalConf.title = '请选择素材分类';
    this.curModalStep = 'second';
  }

  /**
   * @author Terry
   * @description 讲前台资源类型转化为后台资源类型
   * @param { AssetType } item
  */
  handleAssetTypeConvert(item: AssetType) {
    switch (item) {
      case AssetType.Sound: return 'sound';
      case AssetType.Sprite: return 'sprite';
      case AssetType.Stage: return 'background';
      default: return undefined;
    }
  }

  /**
   * @author Terry
   * @description 获取数据
   * @param flag 是否重新赋值数据  true 为重新赋值数据  false 追加数据
  */
  getData(flag: boolean = true) {
    this.loading.page = true;
    if (flag) {
      this.page.pageNo = 1;
      this.page.total = 0;
      this.datas = [];
    }
    let params: IAssetSearchForm = {
      pageSize: this.page.pageSize,
      pageNo: this.page.pageNo,
      type: this.handleAssetTypeConvert(this.curPageTag),
    };
    if (this.activateFlag) {
      const form: any = this.$refs.searchForm.getFormData();
      params = { ...params, ...form };
    } else params = { ...params, title: this.searchTitle };
    api.getAssetJson(params).then((res: any) => {
      this.page.total = res.totalElements;
      const result: any = res.content.map((em: any) => ({
        title: em.title,
        data: JSON.parse(em.data),
        thumbs: em.thumbs ? em.thumbs : `${em.thumbMd5}.${em.thumbExt}`,
        id: em.id,
        imgUrl: `${process.env.VUE_APP_ASSET_HOST}/${em.thumbMd5}.${em.thumbExt}`,
      }));
      this.datas.push(...result);
      this.loading.page = false;
      this.flag = false;
    /* eslint-disable no-return-assign */
    }).catch(() => {
      this.loading.page = false;
      this.flag = false;
    });
  }

  /**
   * @author yubiao
   * @description 搜素词改变事件
   */

  handleSearchChange(v: string) {
    this.searchTitle = v;
    this.getData(true);
  }

  /**
   * @author yubiao
   * @desc 高级搜索提交事件
   */
  handleAdvancedSearch() {
    // const form: any = this.$refs.searchForm.getFormData();
    // const flag: boolean = Object.values(form).some((em: any) => em && em.length > 0);
    // if (flag)
    this.getData(true);
  }

  /**
   * @author yubiao
   * @desc 高级搜索普通搜索切换事件
   * @param { boolean } activate 是否切换
   */
  handleActivateChange(activate: boolean) {
    this.activateFlag = activate;
    if (activate) {
      this.$refs.searchForm.setTitle(this.searchTitle);
      this.searchTitle = '';
    } else this.searchTitle = this.$refs.searchForm.getFormData().title;
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索清空按钮事件
   */
  handleAdvanceClear() {
    this.$refs.searchForm.handleClear();
    this.getData(true);
  }

  /**
   * @author Terry
   * @description 处理标签点击
   * @params tag target 'modal' 模态框 ’page‘ 页面
   */
  handleTagClick(tag: { name: string, imgUrl: any, value: AssetType }, target: 'modal' | 'page') {
    if (target === 'modal' && !this.loading.modal) {
      this.searchValue = '';
      this.curModalTag = tag.value;
    }
    if (target === 'page' && this.curPageTag !== tag.value) {
      this.curPageTag = tag.value;
      this.getData();
    }
  }

  /**
   * @author Terry
   * @description 处理模块的收藏
   * @params  MD5 文件名
   */
  handleModalCheck(md5: string) {
    const index: number = this.checkModalData[this.curModalTag].indexOf(md5);
    if (index >= 0) this.checkModalData[this.curModalTag].splice(index, 1);
    else this.checkModalData[this.curModalTag].push(md5);
  }

  /**
   * @author Terry
   * @description 处理页面的收藏
   * @params MD5 文件名
   */
  handlePageCheck(md5: string) {
    const index: number = this.checkPageData[this.curPageTag].indexOf(md5);
    if (index >= 0) this.checkPageData[this.curPageTag].splice(index, 1);
    else this.checkPageData[this.curPageTag].push(md5);
    this.allotBtn.disabled = !(this.checkPageData.sprites.length > 0
    || this.checkPageData.sounds.length > 0
    || this.checkPageData.stages.length > 0);
    this.removeBtn.disabled = this.allotBtn.disabled;
  }

  /**
   * @author Terry
   * @description 得到角色下的造型
   * @params { string } md5
   */
  compAsset(md5: any, target: 'modal' | 'page') {
    if (target === 'modal') {
      if (this.curModalTag === AssetType.Sprite) {
        const costume: any = this.asset.sprites.filter((em: any) => em.md5 === md5)[0];
        /* eslint-disable dot-notation */
        return costume.json['costumes'].map((em: any) => this.handleAssetConvert(em.baseLayerMD5));
      }
      if (this.curModalTag === AssetType.Sound) return this.handleAssetConvert(md5);
      return null;
    }
    if (target === 'page') {
      if (this.curPageTag === AssetType.Sprite) {
        const md5s: any = md5 && JSON.parse(md5);
        return md5s && md5s.map((em: any) => `${process.env.VUE_APP_ASSET_HOST}/${em}`);
      }
      if (this.curPageTag === AssetType.Sound) return `${process.env.VUE_APP_ASSET_HOST}/${md5}`;
      return null;
    }
  }

  /**
   * @author Terry
   * @description 得到缩略图
   * @params { string } md5
   */
  compCover(md5: string, target: 'modal' | 'page') {
    if (target === 'modal') {
      if (this.curModalTag === AssetType.Sound) return require('./icons/sound-bg.png');
      return this.handleAssetConvert(md5);
    }
    if (target === 'page') {
      if (this.curPageTag === AssetType.Sound) return require('./icons/sound-bg.png');
      return md5;
    }
  }

  /**
   * @author Terry
   * @description 处理图片转化
   * @params { string } md5
   */
  async handleAssetConvert(md5: any) {
    const ext: string = md5.split('.').pop();
    const result = await this.unZipFiles[md5].async(ext === 'svg' ? 'base64' : 'blob');
    if (ext === 'svg') return `data:image/svg+xml;base64,${result}`;
    return URL.createObjectURL(result);
  }

  /**
   * @author Terry
   * @description 关闭modal
   */
  close() {
    if (this.loading.modal) {
      this.msg('正在上传中, 请耐心等待 ~ ', 'warning');
      return;
    }
    this.modalConf.show = false;
    this.modalConf.title = '请选择素材资源';
    this.inputShow = true;
    this.asset.sounds = [];
    this.asset.sprites = [];
    this.asset.stages = [];
    this.checkModalData.sprites = [];
    this.checkModalData.sounds = [];
    this.checkModalData.stages = [];
    this.curModalStep = 'first';
    this.loading.submit = false;
  }

  /**
   * @author Terry
   * @description 解压sb3文件
   * @param { File } sb3文件
   */
  async unZipSb3(): Promise<Array<JSZipObject>> {
    const result = await JsZip.loadAsync(Array.from<File>(this.$refs.upload.files as FileList)[0]);
    return result.files as any;
  }

  /**
   * @author Terry
   * @description 解压sb3并处理project.json
   */
  async handleUpload() {
    this.modalConf.show = true;
    this.curModalTag = AssetType.Sprite;
    this.inputShow = false;
    this.notNeedScripts = [];
    this.unZipSb3().then((res: any) => {
      this.unZipFiles = res;
      this.handleProJson(res['project.json']);
    });
  }

  /**
   * @author Terry
   * @description 处理Project.json
   * @param { JSZipObject } jszip解压后的压缩对象
   */
  async handleProJson(file: JSZipObject) {
    /* eslint-disable prefer-const */
    let jsonObj: any = JSON.parse(await file.async('text'));
    let sprites: Array<any> = jsonObj.targets;
    let stageObj: any = sprites.filter(em => em.isStage)[0];
    let stages: Array<any> = stageObj.costumes;
    // 处理舞台的背景
    stages.forEach((stage: any) => {
      this.asset.stages.push({
        name: stage.name,
        md5: stage.md5ext,
        type: 'backdrop',
        info: stage.dataFormat === 'svg' ? [480, 360, 1] : [960, 720, 2],
      });
    });
    let preSounds: Array<any> = stageObj.sounds;
    preSounds.forEach(sound => this.asset.sounds.push({
      name: sound.name,
      md5: sound.md5ext,
      sampleCount: sound.sampleCount,
      rate: sound.rate,
      format: sound.format,
      // tags: ['courses'],
    }));
    sprites = sprites.filter(em => !em.isStage);
    /* eslint-disable array-callback-return */
    this.asset.sprites = sprites.map((sprite) => {
      let result: any = {
        name: sprite.name,
        md5: sprite.costumes[0].md5ext,
        sprite3: true,
        source: Object.assign({}, sprite, { visible: true }),
      };
      /* eslint-disable prefer-destructuring */
      let stageSounds: Array<any> = sprite.sounds;
      let costumes: Array<any> = sprite.costumes;
      result.json = {
        name: sprite.name,
        sounds: stageSounds.map(sound => ({
          soundName: sound.name,
          soundID: -1,
          md5: sound.md5ext,
          sampleCount: sound.sampleCount,
          rate: sound.rate,
          format: sound.format,
        })),
        costumes: costumes.map(costume => ({
          costumeName: costume.name,
          baseLayerID: -1,
          baseLayerMD5: costume.md5ext,
          bitmapResolution: costume.bitmapResolution,
          rotationCenterX: costume.rotationCenterX,
          rotationCenterY: costume.rotationCenterY,
        })),
      };
      return result;
    });
  }

  @Watch('checkModalData', { immediate: false, deep: true })
  watchModalCheck() {
    let flag: boolean = false;
    flag = Object.values(this.checkModalData).some((arr: any) => arr.length > 0);
    this.nextBtn.disabled = !flag;
  }
}
